export default __webpack_public_path__ + "static/blue-4e4e85a2121b64ea617946b15d93c133.png";